<template>
    <div>
        <v-row>
            <v-col cols="12" md="3">
                <v-select @change="getData()" label="Wybierz typ" :items="[{name: 'Wszystkie', value: null},{name: 'Nie wyświetlone', value: 'unseen'}, {name: 'Wyświetlone', value: 'seen'}]" v-model="params.type" item-text="name" item-value="value"></v-select>
            </v-col>
        </v-row>
        <v-list v-if="data && data.data.length > 0">
            <v-list-item @click="handleClick(item)" v-for="item in data.data">
                <v-list-item-content>{{item.content}}</v-list-item-content>
                <v-list-item-action>
                    <v-btn outlined icon><v-icon>mdi-eye</v-icon></v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <v-pagination
                @input="getData()"
                v-model="params.page"
                :length="data.last_page"
                v-if="data"
        ></v-pagination>
    </div>
</template>
<script>
    import {getNotifications} from "../../api/notifications";

    export default {
        data:() => {return {
            data: null,
            params:{
                page: 1,
                all: true
            }
        }},
        mounted(){
            this.getData();
        },
        methods:{
            getData(){
                getNotifications(this.params).then(response => {
                    this.data = response;
                }).catch(e => {

                })
            },
            handleClick(item){
                if(item.link){
                    this.$router.push(item.link);
                }
            },
        }
    }
</script>
